/* eslint-disable */
import React from "react";
import { supabase } from "./supabaseClient";

const C = {
  primary:"#1a6b3c", primaryPale:"#e8f5ee", primaryDark:"#0d3d1f",
  amber:"#d97706",   amberPale:"#fffbeb",
  rose:"#e11d48",    rosePale:"#fef2f2",
  blue:"#2563eb",    bluePale:"#eff6ff",
  purple:"#7c3aed",  purplePale:"#f5f3ff",
  text:"#111827",    muted:"#6b7280",  border:"#d1fae5",
  white:"#ffffff",   shadow:"rgba(0,0,0,0.06)",
};

const ASSET_TYPES = [
  { id:"computer",   label:"Computer",    icon:"🖥️" },
  { id:"laptop",     label:"Laptop",      icon:"💻" },
  { id:"tablet",     label:"Tablet",      icon:"📱" },
  { id:"projector",  label:"Projector",   icon:"📽️" },
  { id:"printer",    label:"Printer",     icon:"🖨️" },
  { id:"furniture",  label:"Furniture",   icon:"🪑" },
  { id:"other",      label:"Other",       icon:"📦" },
];

const CONDITION_META = {
  excellent: { label:"Excellent", col:"#16a34a", bg:"#f0fdf4" },
  good:      { label:"Good",      col:C.blue,    bg:C.bluePale },
  fair:      { label:"Fair",      col:C.amber,   bg:C.amberPale },
  poor:      { label:"Poor",      col:C.rose,    bg:C.rosePale },
};

const STATUS_META = {
  active:       { label:"Active",       col:"#16a34a", bg:"#f0fdf4", border:"#bbf7d0" },
  under_repair: { label:"Under Repair", col:C.amber,   bg:C.amberPale, border:"#fde68a" },
  disposed:     { label:"Disposed",     col:C.muted,   bg:"#f3f4f6", border:"#e5e7eb" },
  lost:         { label:"Lost",         col:C.rose,    bg:C.rosePale, border:"#fecaca" },
};

const blankForm = { asset_name:"", asset_type:"computer", asset_tag:"", serial_number:"", purchase_date:"", purchase_price:"", supplier:"", condition:"good", status:"active", location:"", assigned_to:"", warranty_expiry:"", last_checked:"", notes:"" };

const todayStr = () => new Date().toISOString().split("T")[0];
const fmtDate  = d => d ? new Date(d+"T00:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—";
const daysUntil = d => { if(!d) return null; const diff=new Date(d)-new Date(); return Math.ceil(diff/(1000*60*60*24)); };

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{position:"fixed",top:20,right:20,zIndex:9999,background:toast.ok?"#f0fdf4":"#fef2f2",color:toast.ok?"#16a34a":"#dc2626",border:`1px solid ${toast.ok?"#bbf7d0":"#fecaca"}`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,boxShadow:"0 4px 18px rgba(0,0,0,.15)"}}>
      {toast.msg}
    </div>
  );
}

const inp = {padding:"9px 12px",borderRadius:8,border:`1px solid #e5e7eb`,fontSize:13,boxSizing:"border-box",width:"100%"};
const label = (txt) => <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:4,textTransform:"uppercase"}}>{txt}</label>;

export function AssetRegisterAdmin() {
  const [assets,     setAssets]     = React.useState([]);
  const [staffList,  setStaffList]  = React.useState([]);
  const [loading,    setLoading]    = React.useState(true);
  const [view,       setView]       = React.useState("list"); // "list" | "form" | "analytics"
  const [editAsset,  setEditAsset]  = React.useState(null); // null = new
  const [form,       setForm]       = React.useState(blankForm);
  const [saving,     setSaving]     = React.useState(false);
  const [toast,      setToast]      = React.useState(null);
  const [confirmDel, setConfirmDel] = React.useState(null);
  const [filterType,   setFilterType]   = React.useState("all");
  const [filterStatus, setFilterStatus] = React.useState("all");
  const [searchQ,      setSearchQ]      = React.useState("");
  const [expandedId,   setExpandedId]   = React.useState(null);

  const showToast = (msg,ok=true)=>{setToast({msg,ok});setTimeout(()=>setToast(null),3500);};
  const setF = (k,v) => setForm(p=>({...p,[k]:v}));

  React.useEffect(()=>{
    (async()=>{
      const [{data:aRows},{data:sRows}] = await Promise.all([
        supabase.from("asset_register").select("*").order("created_at",{ascending:false}),
        supabase.from("staff").select("id,name").eq("status","Active").order("name"),
      ]);
      setAssets(aRows||[]);
      setStaffList(sRows||[]);
      setLoading(false);
    })();
  },[]);

  const openNew = () => { setForm({...blankForm, last_checked:todayStr()}); setEditAsset(null); setView("form"); };
  const openEdit = (a) => { setForm({...blankForm,...a, purchase_price:a.purchase_price||"", purchase_date:a.purchase_date||"", warranty_expiry:a.warranty_expiry||"", last_checked:a.last_checked||"", }); setEditAsset(a); setView("form"); };

  const save = async () => {
    if (!form.asset_name.trim()) { showToast("Asset name is required.",false); return; }
    setSaving(true);
    const payload = { ...form, purchase_price:form.purchase_price?Number(form.purchase_price):null, purchase_date:form.purchase_date||null, warranty_expiry:form.warranty_expiry||null, last_checked:form.last_checked||null, asset_tag:form.asset_tag||null, serial_number:form.serial_number||null, supplier:form.supplier||null, location:form.location||null, assigned_to:form.assigned_to||null, notes:form.notes||null };
    if (editAsset) {
      const {error} = await supabase.from("asset_register").update(payload).eq("id",editAsset.id);
      if (error){ showToast("Error: "+error.message,false); setSaving(false); return; }
      setAssets(p=>p.map(a=>a.id===editAsset.id?{...a,...payload}:a));
      showToast("Asset updated ✅");
    } else {
      const {data,error} = await supabase.from("asset_register").insert(payload).select().single();
      if (error){ showToast("Error: "+error.message,false); setSaving(false); return; }
      setAssets(p=>[data,...p]);
      showToast("Asset added ✅");
    }
    setView("list"); setSaving(false);
  };

  const deleteAsset = async (id) => {
    const {error} = await supabase.from("asset_register").delete().eq("id",id);
    if (error){ showToast("Error: "+error.message,false); return; }
    setAssets(p=>p.filter(a=>a.id!==id));
    setConfirmDel(null);
    showToast("Asset deleted.");
  };

  // Analytics
  const analytics = React.useMemo(()=>{
    const byType = {};
    ASSET_TYPES.forEach(t=>{ byType[t.id]=0; });
    assets.forEach(a=>{ byType[a.asset_type]=(byType[a.asset_type]||0)+1; });
    const active = assets.filter(a=>a.status==="active").length;
    const repair = assets.filter(a=>a.status==="under_repair").length;
    const totalVal = assets.filter(a=>a.purchase_price).reduce((s,a)=>s+Number(a.purchase_price),0);
    const warrantyExpiringSoon = assets.filter(a=>{ const d=daysUntil(a.warranty_expiry); return d!=null&&d>0&&d<=90; });
    const warrantyExpired      = assets.filter(a=>{ const d=daysUntil(a.warranty_expiry); return d!=null&&d<=0; });
    const conditionCounts = Object.fromEntries(Object.keys(CONDITION_META).map(k=>[k,assets.filter(a=>a.condition===k).length]));
    return {byType,active,repair,totalVal,warrantyExpiringSoon,warrantyExpired,conditionCounts};
  },[assets]);

  const filtered = assets.filter(a=>
    (filterType==="all"||a.asset_type===filterType)&&
    (filterStatus==="all"||a.status===filterStatus)&&
    (!searchQ||(a.asset_name||"").toLowerCase().includes(searchQ.toLowerCase())||(a.asset_tag||"").toLowerCase().includes(searchQ.toLowerCase())||(a.serial_number||"").toLowerCase().includes(searchQ.toLowerCase())||(a.assigned_to||"").toLowerCase().includes(searchQ.toLowerCase()))
  );

  const typeIcon = (id) => ASSET_TYPES.find(t=>t.id===id)?.icon||"📦";

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Toast toast={toast}/>

      {/* Header */}
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12,marginBottom:14}}>
          <div>
            <div style={{fontWeight:900,fontSize:17,color:C.primary}}>🗄️ Asset Register</div>
            <div style={{fontSize:12,color:C.muted,marginTop:2}}>{assets.length} assets · {analytics.active} active · {analytics.repair} under repair</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            {["list","analytics"].map(v=>(
              <button key={v} onClick={()=>setView(v)}
                style={{background:view===v?C.primary:"#f3f4f6",color:view===v?"white":"#374151",border:"none",borderRadius:9,padding:"8px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                {v==="list"?"📋 Assets":"📊 Analytics"}
              </button>
            ))}
            <button onClick={openNew} style={{background:`linear-gradient(135deg,${C.primary},#0d9488)`,color:"white",border:"none",borderRadius:10,padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer"}}>+ Add Asset</button>
          </div>
        </div>
        {/* Quick stats */}
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          {[["🖥️","Total",assets.length,C.primary,C.primaryPale],["✅","Active",analytics.active,"#16a34a","#f0fdf4"],["🔧","Repair",analytics.repair,C.amber,C.amberPale],["⚠️","Warranty <90d",analytics.warrantyExpiringSoon.length,C.rose,C.rosePale]].map(([icon,lbl,val,col,bg])=>(
            <div key={lbl} style={{background:bg,borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:8,border:`1px solid ${col}33`}}>
              <span style={{fontSize:16}}>{icon}</span>
              <div><div style={{fontWeight:900,fontSize:18,color:col,lineHeight:1}}>{val}</div><div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase"}}>{lbl}</div></div>
            </div>
          ))}
          {analytics.totalVal>0&&(
            <div style={{background:C.purplePale,borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:8,border:`1px solid ${C.purple}33`}}>
              <span style={{fontSize:16}}>💷</span>
              <div><div style={{fontWeight:900,fontSize:18,color:C.purple,lineHeight:1}}>£{analytics.totalVal.toLocaleString()}</div><div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase"}}>Total Value</div></div>
            </div>
          )}
        </div>
      </div>

      {/* ── Add / Edit Form ── */}
      {view==="form"&&(
        <div style={{background:C.white,borderRadius:14,border:`1px solid ${C.border}`,padding:"20px 22px",display:"flex",flexDirection:"column",gap:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
            <div style={{fontWeight:800,fontSize:15,color:C.primary}}>{editAsset?"✏️ Edit Asset":"➕ New Asset"}</div>
            <button onClick={()=>setView("list")} style={{background:"#f3f4f6",border:"none",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer",color:C.muted}}>← Back</button>
          </div>

          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:12}}>
            <div style={{gridColumn:"1/-1"}}>{label("Asset Name *")}<input value={form.asset_name} onChange={e=>setF("asset_name",e.target.value)} placeholder="e.g. Dell Latitude 5520" style={inp}/></div>
            <div>{label("Type")}<select value={form.asset_type} onChange={e=>setF("asset_type",e.target.value)} style={inp}>{ASSET_TYPES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.label}</option>)}</select></div>
            <div>{label("Asset Tag / Barcode")}<input value={form.asset_tag} onChange={e=>setF("asset_tag",e.target.value)} placeholder="QK-001" style={inp}/></div>
            <div>{label("Serial Number")}<input value={form.serial_number} onChange={e=>setF("serial_number",e.target.value)} placeholder="SN123456" style={inp}/></div>
            <div>{label("Condition")}<select value={form.condition} onChange={e=>setF("condition",e.target.value)} style={inp}>{Object.entries(CONDITION_META).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select></div>
            <div>{label("Status")}<select value={form.status} onChange={e=>setF("status",e.target.value)} style={inp}>{Object.entries(STATUS_META).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select></div>
            <div>{label("Location")}<input value={form.location} onChange={e=>setF("location",e.target.value)} placeholder="Room 101, Staff Room…" style={inp}/></div>
            <div>{label("Assigned To")}<select value={form.assigned_to} onChange={e=>setF("assigned_to",e.target.value)} style={inp}><option value="">— Unassigned —</option>{staffList.map(s=><option key={s.id} value={s.name}>{s.name}</option>)}</select></div>
            <div>{label("Purchase Date")}<input type="date" value={form.purchase_date} onChange={e=>setF("purchase_date",e.target.value)} style={inp}/></div>
            <div>{label("Purchase Price (£)")}<input type="number" min="0" step="0.01" value={form.purchase_price} onChange={e=>setF("purchase_price",e.target.value)} placeholder="0.00" style={inp}/></div>
            <div>{label("Supplier")}<input value={form.supplier} onChange={e=>setF("supplier",e.target.value)} placeholder="Supplier name" style={inp}/></div>
            <div>{label("Warranty Expiry")}<input type="date" value={form.warranty_expiry} onChange={e=>setF("warranty_expiry",e.target.value)} style={inp}/></div>
            <div>{label("Last Checked")}<input type="date" value={form.last_checked} onChange={e=>setF("last_checked",e.target.value)} style={inp}/></div>
            <div style={{gridColumn:"1/-1"}}>{label("Notes")}<textarea value={form.notes} onChange={e=>setF("notes",e.target.value)} rows={2} placeholder="Any additional notes…" style={{...inp,resize:"vertical",fontFamily:"inherit"}}/></div>
          </div>

          <div style={{display:"flex",gap:10}}>
            <button onClick={save} disabled={saving} style={{background:saving?"#9ca3af":`linear-gradient(135deg,${C.primary},#0d9488)`,color:"white",border:"none",borderRadius:10,padding:"10px 24px",fontWeight:700,fontSize:13,cursor:saving?"not-allowed":"pointer"}}>
              {saving?"Saving…":"💾 Save Asset"}
            </button>
            <button onClick={()=>setView("list")} style={{background:"#f3f4f6",color:"#374151",border:"1px solid #e5e7eb",borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {/* ── Analytics ── */}
      {view==="analytics"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* By type */}
          <div style={{background:C.white,borderRadius:14,padding:"16px 20px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:13,color:C.text,marginBottom:12}}>Assets by Type</div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {ASSET_TYPES.map(t=>(
                <div key={t.id} style={{background:C.primaryPale,borderRadius:10,padding:"10px 16px",textAlign:"center",minWidth:80,border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:22}}>{t.icon}</div>
                  <div style={{fontWeight:900,fontSize:18,color:C.primary,lineHeight:1}}>{analytics.byType[t.id]||0}</div>
                  <div style={{fontSize:10,color:C.muted,fontWeight:600}}>{t.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
            {/* Condition breakdown */}
            <div style={{background:C.white,borderRadius:14,padding:"16px 20px",border:`1px solid ${C.border}`,flex:1,minWidth:220}}>
              <div style={{fontWeight:800,fontSize:13,color:C.text,marginBottom:12}}>Condition Breakdown</div>
              {Object.entries(CONDITION_META).map(([k,m])=>{
                const count = analytics.conditionCounts[k]||0;
                const max = Math.max(1,...Object.values(analytics.conditionCounts));
                return(
                  <div key={k} style={{marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                      <span style={{fontWeight:700,color:m.col}}>{m.label}</span>
                      <span style={{color:C.muted}}>{count}</span>
                    </div>
                    <div style={{background:"#f3f4f6",borderRadius:6,height:7,overflow:"hidden"}}>
                      <div style={{width:`${Math.round(count/max*100)}%`,height:"100%",background:m.col,borderRadius:6}}/>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Warranty alerts */}
            <div style={{background:C.white,borderRadius:14,padding:"16px 20px",border:`1px solid ${C.border}`,flex:1,minWidth:220}}>
              <div style={{fontWeight:800,fontSize:13,color:C.text,marginBottom:12}}>⚠️ Warranty Alerts</div>
              {analytics.warrantyExpired.length===0&&analytics.warrantyExpiringSoon.length===0&&(
                <div style={{color:C.muted,fontSize:13}}>All warranties are current.</div>
              )}
              {analytics.warrantyExpired.slice(0,5).map(a=>(
                <div key={a.id} style={{background:C.rosePale,borderRadius:8,padding:"7px 10px",marginBottom:6,fontSize:12}}>
                  <div style={{fontWeight:700,color:C.rose}}>{a.asset_name}</div>
                  <div style={{color:C.muted}}>Expired {fmtDate(a.warranty_expiry)}</div>
                </div>
              ))}
              {analytics.warrantyExpiringSoon.map(a=>{
                const d=daysUntil(a.warranty_expiry);
                return(
                  <div key={a.id} style={{background:C.amberPale,borderRadius:8,padding:"7px 10px",marginBottom:6,fontSize:12}}>
                    <div style={{fontWeight:700,color:C.amber}}>{a.asset_name}</div>
                    <div style={{color:C.muted}}>Expires in {d} days ({fmtDate(a.warranty_expiry)})</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* ── Asset List ── */}
      {view==="list"&&(
        <>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="🔍 Search name, tag, serial, assignee…"
              style={{flex:2,minWidth:200,padding:"8px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13}}/>
            <select value={filterType} onChange={e=>setFilterType(e.target.value)} style={{padding:"8px 10px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:12}}>
              <option value="all">All Types</option>
              {ASSET_TYPES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.label}</option>)}
            </select>
            <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{padding:"8px 10px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:12}}>
              <option value="all">All Statuses</option>
              {Object.entries(STATUS_META).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
            </select>
          </div>

          {loading ? <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div> : (
            filtered.length===0
              ? <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>No assets found. Click "+ Add Asset" to get started.</div>
              : <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {filtered.map(a=>{
                    const sm = STATUS_META[a.status]||STATUS_META.active;
                    const cm = CONDITION_META[a.condition]||CONDITION_META.good;
                    const warrantyDays = daysUntil(a.warranty_expiry);
                    const isOpen = expandedId===a.id;
                    return(
                      <div key={a.id} style={{background:C.white,borderRadius:12,border:`1.5px solid ${sm.border}`,overflow:"hidden"}}>
                        <div onClick={()=>setExpandedId(isOpen?null:a.id)} style={{padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10,flexWrap:"wrap"}}>
                          <div style={{display:"flex",gap:12,alignItems:"center"}}>
                            <span style={{fontSize:22}}>{typeIcon(a.asset_type)}</span>
                            <div>
                              <div style={{fontWeight:800,fontSize:14,color:C.text}}>{a.asset_name}</div>
                              <div style={{fontSize:11,color:C.muted}}>{a.asset_tag&&`#${a.asset_tag} · `}{a.location||"No location"}{a.assigned_to&&` · ${a.assigned_to}`}</div>
                            </div>
                          </div>
                          <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                            <span style={{background:cm.bg,color:cm.col,borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700}}>{cm.label}</span>
                            <span style={{background:sm.bg,color:sm.col,border:`1px solid ${sm.border}`,borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700}}>{sm.label}</span>
                            {warrantyDays!=null&&warrantyDays<=90&&warrantyDays>0&&<span style={{background:C.amberPale,color:C.amber,borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700}}>⚠️ {warrantyDays}d warranty</span>}
                            {warrantyDays!=null&&warrantyDays<=0&&<span style={{background:C.rosePale,color:C.rose,borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700}}>⛔ Warranty expired</span>}
                            <button onClick={e=>{e.stopPropagation();openEdit(a);}} style={{background:C.primaryPale,color:C.primary,border:"none",borderRadius:6,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>✏️</button>
                            <button onClick={e=>{e.stopPropagation();setConfirmDel(a.id);}} style={{background:C.rosePale,color:C.rose,border:"none",borderRadius:6,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>🗑️</button>
                            <span style={{color:C.muted,fontSize:12}}>{isOpen?"▲":"▼"}</span>
                          </div>
                        </div>

                        {/* Inline delete confirm */}
                        {confirmDel===a.id&&(
                          <div style={{margin:"0 18px 14px",background:C.rosePale,borderRadius:9,padding:"10px 14px",border:"1px solid #fecaca"}}>
                            <div style={{fontSize:13,color:C.text,marginBottom:8,fontWeight:600}}>Delete "{a.asset_name}"? This cannot be undone.</div>
                            <div style={{display:"flex",gap:8}}>
                              <button onClick={()=>deleteAsset(a.id)} style={{background:C.rose,color:"white",border:"none",borderRadius:7,padding:"6px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>🗑️ Delete</button>
                              <button onClick={()=>setConfirmDel(null)} style={{background:"#f3f4f6",color:"#374151",border:"1px solid #e5e7eb",borderRadius:7,padding:"6px 12px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Cancel</button>
                            </div>
                          </div>
                        )}

                        {/* Expanded detail */}
                        {isOpen&&(
                          <div style={{padding:"0 18px 16px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:10}}>
                            {[["Serial No.",a.serial_number],["Supplier",a.supplier],["Purchased",fmtDate(a.purchase_date)],["Price",a.purchase_price?`£${Number(a.purchase_price).toLocaleString()}`:"—"],["Warranty",fmtDate(a.warranty_expiry)],["Last Checked",fmtDate(a.last_checked)]].map(([k,v])=>(
                              <div key={k} style={{background:"#f9fafb",borderRadius:8,padding:"8px 12px"}}>
                                <div style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:2}}>{k}</div>
                                <div style={{fontSize:12,color:C.text,fontWeight:600}}>{v||"—"}</div>
                              </div>
                            ))}
                            {a.notes&&<div style={{gridColumn:"1/-1",background:"#f9fafb",borderRadius:8,padding:"8px 12px"}}><div style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:2}}>Notes</div><div style={{fontSize:12,color:C.text}}>{a.notes}</div></div>}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
          )}
        </>
      )}
    </div>
  );
}
